export const FEATURE_ID = {
  RESIZE: 'RESIZE',
  DUB: 'DUB',
  REPHRASE: 'REPHRASE',
  CAPTIONS: 'CAPTIONS',
  AI_AVATAR: 'AI_AVATAR',
  UPSCALE: 'UPSCALE',
};

export const FEATURE_ASSETS = {
  [FEATURE_ID.RESIZE]: {
    IMAGE:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Reformat.jpg?v=2',
    VIDEO:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Reformat.mp4',
  },
  [FEATURE_ID.DUB]: {
    IMAGE:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Translate.jpg?v=2',
    VIDEO:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Translate.mp4',
  },
  [FEATURE_ID.REPHRASE]: {
    IMAGE:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Rephrase.jpg?v=2',
    VIDEO:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Rephrase.mp4',
  },
  [FEATURE_ID.CAPTIONS]: {
    IMAGE:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Captions.jpg?v=2',
    VIDEO:
      'https://storage.googleapis.com/brands-public-assets/content-lab/Captions.mp4',
  },
  [FEATURE_ID.AI_AVATAR]: {
    IMAGE:
      'https://storage.googleapis.com/brands-public-assets/content-lab/AI_Avatar.jpg?v=2',
    VIDEO:
      'https://storage.googleapis.com/brands-public-assets/content-lab/AI_Avatar.mp4',
  },
  [FEATURE_ID.UPSCALE]: {
    IMAGE:
      'https://storage.googleapis.com/brands-public-assets/content-lab/AI_Avatar.jpg?v=2',
    VIDEO:
      'https://storage.googleapis.com/brands-public-assets/content-lab/AI_Avatar.mp4',
  },
};

export type FeatureId = (typeof FEATURE_ID)[keyof typeof FEATURE_ID];
